import React, { useState } from 'react';
import { Button, Modal, Row, Col, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import CategorySelection from '../AddSiteAsset/CategorySelection';
import Alert from 'components/Common/Alert';

 function ExportCategory({ 
    showExportModal, 
    setShowExportModal,
    handleExport,
    setCategoryId,
    companyId,
  }) {

    const darkMode = useSelector(state => state.app.darkMode);

    const [categoryName, setCategoryName] = useState("");

    const hideModal = () => setShowExportModal(false);

    const confirmExport = () => {
      Alert({
        html: `<span>Are you sure you wish to export the assets from ${categoryName ? `<span class='font-weight-bolder'>${categoryName}</span>` : 'this category'}?</span>`,
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
      })
      .then(result => {
        if (result.value) {
          handleExport({ filterExport: false, categoryExport: true })
          hideModal();
        }
      })
      .catch((error) => console.log('error: ', error));
    }

  return (
    <>
      <Modal
        id='bulk-import-assets-modal'
        backdrop='static'    
        centered
        keyboard={false}
        onHide={hideModal}
        show={showExportModal}
        size='lg'
      >
        <Modal.Header
          closeButton
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Modal.Title className='w-100'>
            <Row className='d-flex justify-content-between align-items-center'>
              <Col xs="auto" sm="auto" md="auto" lg="auto">
                <span>Export Category</span>
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className='container' style={{ minHeight: "100px" }}>

            <CategorySelection
              key={'category'}
              companyId={companyId}
              handleSetCategoryId={setCategoryId}
              handleSetCategoryName={setCategoryName}
              message="1. Choose an Asset Category to export assets from:"
            />

            <Button
              className='mt-2'
              onClick={confirmExport}
            >
              Export
            </Button>

          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <Button className="mr-2 p-2" variant="primary" onClick={hideModal}>
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

    </>
  )
}

export default ExportCategory;